import { useState, useEffect, useCallback } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import GlobalHeader from './GlobalHeader';
import GlobalSlideMenu from './GlobalSlideMenu';
import MobileNav from './MobileNav';
import { apiFetch } from '../utils/api';


export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) {
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await apiFetch(`/api/auth/me`);

        if (!response.ok) throw new Error('Not authenticated');

        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  const handleLogout = async () => {
    try {
      await apiFetch(`/api/auth/logout`, { method: 'POST' });
    } catch {}
    navigate('/login');
  };

  // Keyboard shortcuts (F1=Entry, F2=Exit, F3=Customers, F4=CashRegister, F5=Dashboard)
  const handleKeyDown = useCallback((e) => {
    const tag = document.activeElement?.tagName?.toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
    if (e.key === 'F1') { e.preventDefault(); navigate('/entry'); }
    else if (e.key === 'F2') { e.preventDefault(); navigate('/exit'); }
    else if (e.key === 'F5') { e.preventDefault(); navigate('/dashboard'); }
    else if (e.key === 'F3') { e.preventDefault(); navigate('/customers'); }
    else if (e.key === 'F4') { e.preventDefault(); navigate('/cash-register'); }
  }, [navigate]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-lg text-slate-600">Φόρτωση...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-950">
      <GlobalHeader currentUser={user} onLogout={handleLogout} />
      <GlobalSlideMenu currentUser={user} onLogout={handleLogout} />
      <main>{children}</main>
      <MobileNav />
    </div>
  );
}
